// extracted by mini-css-extract-plugin
module.exports = {"markdown":"style_markdown__1C5Mhw_x-xJLzokFzjyNPL","secondaryText":"style_secondaryText__2ZrrCywqprIr8mBlNGlSp3"};